import { useEffect, useState } from "react";
import { Modal, NavLink } from "react-bootstrap";

import { storageGet } from "../../api";
import LoadingCentered from "../loaders/loadingcentered";
import { jsError } from "../utils";


// display a single attachment inside a modal with filename and download link
export function AttachmentModal({attachment, onCancel }) {

  const [objectURL, setObjectURL] = useState("");
  const [filename, setFilename] = useState("");

  useEffect(() => {

    async function fetchAttachment() {
      setObjectURL("");
      setFilename("");

      if (attachment.key) { // get attachment from storage server
        delete attachment.data; // data property is unneccessary for storageGet()
        try {
          const res = await storageGet(attachment);
          if (res.status === 200) {
            const disposition = res.headers["content-disposition"];
            if (disposition !== null) {
              const filename = disposition.match(/filename\*=UTF-8''(.+)$/);
              if (filename !== null) {
                setFilename( decodeURIComponent(filename[1]) );
              }
            }
            setObjectURL( URL.createObjectURL(res.data) );
          }
        }
        catch (error) {
          jsError(error);
        }
      }
      else { // display new attachment (not yet uploaded)
        setFilename(attachment.data.filename);
        setObjectURL( URL.createObjectURL(attachment.data.file) );
      }
    }

    if (attachment !== null) {
      fetchAttachment();
    }

    return () => URL.revokeObjectURL(objectURL); // release reference to the file
  }, [attachment]);

  return (
    <Modal show={attachment !== null} onHide={onCancel} fullscreen>
      <Modal.Header closeButton onHide={onCancel}>
        <NavLink href={objectURL} target="_blank" rel="noreferrer" download={filename}><b>⭳</b> {filename}</NavLink>
      </Modal.Header>
      <LoadingCentered show={!objectURL} />
      <iframe style={{height: "85vh"}} src={objectURL} />
    </Modal>
  );
}
